import { render, staticRenderFns } from "./CartReviewTotal.vue?vue&type=template&id=18ad69dc&scoped=true&"
import script from "./CartReviewTotal.vue?vue&type=script&lang=ts&"
export * from "./CartReviewTotal.vue?vue&type=script&lang=ts&"
import style0 from "./CartReviewTotal.vue?vue&type=style&index=0&id=18ad69dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad69dc",
  null
  
)

export default component.exports